export const zeroTax = [
  { id: 1, label: 'Exempted' },
  { id: 2, label: 'Nil Rated' },
  { id: 3, label: 'Non GST Supply' },
];
